export type TBaseDictionaryField = {
    id: number,
    name: string,
}

export type TDictionary = {
    programs: TBaseDictionaryField[],
    subjects: TBaseDictionaryField[],
}

export type TSchool = {
    id: number;
    name: string;
    level: number;
    address: string;
}

export type TParticipant = {
    [key: string]: string | number | boolean;
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    schoolId: string,
    schoolLevel: string,
    programName: string,
    programId: string,
    subjectId: string,
    marketingAgreement: boolean,
    emailAgreement: boolean,
    callAgreement: boolean,
}

export enum ProgramType {
    EGZAMIN_7 = '7',
    EGZAMIN_8 = '8'
}
